<template>
  <footer class="footer">
    <div class="footer-container">

      <div class="footer-column">
        <h4>Contact Us</h4>
        <ul>
          <li>
            <a href="mailto:office@newstarfocus.com">Email: office@newstarfocus.com</a>
          </li>
        </ul>
      </div>

      <div class="footer-column">
        <h4>Community</h4>
        <ul>
          <li><a href="https://www.facebook.com/profile.php?id=61552554818337">Facebook</a></li>
          <li><a href="https://www.youtube.com/channel/UCsY9Ne1CVp7npNdw0e6yYpg">YouTube</a></li>
          <li><a href="https://www.tiktok.com/@loveshots.app">TikTok</a></li>
        </ul>
      </div>

    </div>
    <div class="footer-text">
      Copyright 2026, Newstar Focus Limited.
    </div>
    <div class="footer-text">
      All Rights Reserved.
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  color: #d1d1d1;
  height: 3.4rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  background: #1b1a1a;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 26px;
}

.footer-container {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  width: 40%;
}

.footer-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.footer-column h4 {
  font-size: 0.375rem;
  font-weight: bold;
  color: #d1d1d1;
  margin-bottom: 0.2rem;
}

.footer-column ul {
  list-style: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* 左对齐所有子元素 */
}

.footer-column li {
  font-size: 0.3rem;
  margin-bottom: 0.1rem;
  text-align: left;
  /* 确保文本左对齐 */
}

.footer-text {
  font-size: 0.2rem;
  color: #8d8c8c;
}

.footer-column a {
  color: #b3b3b3;
  text-decoration: none;
}

.footer-column a:hover {
  color: #c1304d;
}
</style>
